// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { HttpClient } from '@angular/common/http';
// import { inject, Injectable, OnDestroy } from '@angular/core';
// import { Subject, takeUntil } from 'rxjs';
// import { environment } from '../../environments/environment';
// import { TranslateService } from '@ngx-translate/core';
// import { ToasterService } from './toaster.service';
// import { apiUrls } from '../core/constants/apiUrls.const';

// @Injectable({
//   providedIn: 'root',
// })
// export class ImageUploadService implements OnDestroy {
//   private destroy$ = new Subject<void>();
//   private http = inject(HttpClient);
//   private translate = inject(TranslateService);
//   private toast = inject(ToasterService);

//   onFileChange(event: any): Promise<any> {
//     return new Promise((resolve: any) => {
//       const input = event.target as HTMLInputElement;

//       if (input.files && input.files[0]) {
//         const file = input.files[0];
//         const ext = file.name.split('.').pop()?.toLowerCase();
//         const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
//         const maxSizeInBytes = 2 * 1024 * 1024;
//         if (ext && !allowedExtensions.includes(ext)) {
//           this.toast.showError(this.translate.instant('imageValidation'));
//           input.value = '';
//           return resolve(false);
//         }
//         if (file.size > maxSizeInBytes) {
//           this.toast.showError(this.translate.instant('FileSize'));
//           input.value = '';
//           return resolve(false);
//         }

//         const formData = new FormData();
//         formData.append('file', file);

//         this.http
//           .post(`${environment.base_url}${apiUrls.uploadFile}`, formData)
//           .pipe(takeUntil(this.destroy$))
//           .subscribe({
//             next: (res: any) => {
//               input.value = '';
//               resolve(res);
//             },
//             error: () => {
//               input.value = '';
//               resolve(false);
//             },
//           });
//       } else {
//         input.value = '';
//         resolve(false);
//       }
//     });
//   }


//   ngOnDestroy(): void {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }
// }

/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from './toaster.service';
import { apiUrls } from '../core/constants/apiUrls.const';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private http = inject(HttpClient);
  // private _spinnerService = inject(SpinnerService);
  private translate = inject(TranslateService);
  private toast = inject(ToasterService);

  onFileChange(event: any, type: 'image' | 'doc'): Promise<any> {
    return new Promise((resolve: any) => {
      const input = event.target as HTMLInputElement;
  
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const ext = file.name.split('.').pop()?.toLowerCase();
  
        let allowedExtensions: string[] = [];
        let maxSizeInBytes = 5 * 1024 * 1024; // default 5MB
  
        if (type === 'image') {
          allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
        } else if (type === 'doc') {
          allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
          maxSizeInBytes = 5 * 1024 * 1024; // e.g., 5MB for resumes
        }
  
        if (ext && !allowedExtensions.includes(ext)) {
          this.toast.showError(this.translate.instant('InvalidFileType'));
          input.value = '';
          return resolve(false);
        }
  
        if (file.size > maxSizeInBytes) {
          this.toast.showError(this.translate.instant('FileSizeExceeded'));
          input.value = '';
          return resolve(false);
        }
  
        const formData = new FormData();
        formData.append('file', file);
  
        this.http
          .post(`${environment.base_url}${apiUrls.uploadFile}`, formData)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res: any) => {
              input.value = '';
              resolve(res);
            },
            error: () => {
              input.value = '';
              resolve(false);
            },
          });
      } else {
        input.value = '';
        resolve(false);
      }
    });
  }
  

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

